
<template>
    <footer class="container py-4">
        <div style="float:left;">
        © {{ year }} - We Don't Buy Crime
        </div>
        <div style="float:right; text-align:center;">
            Powered by
            <br>
            <img src="../../assets/SmartWaterLogo-130x96.gif">
        </div>
    </footer>
</template>

<script>
export default {
    data: function () {
        return {
            year : (new Date()).getFullYear(),
        }
    },
}
</script>